<template>
  <v-dialog v-model="dialog"
            fullscreen>
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="red lighten-2"
             dark
             v-bind="attrs"
             v-on="on">
        Content Library
      </v-btn>
    </template>
    <v-card flat
            tile>
      <v-toolbar color="primary"
                 class="mb-4">
        <v-toolbar-title class="d-flex flex-grow-1 justify-end">
          <v-btn @click.prevent="dialog = false">
            Close
          </v-btn>
        </v-toolbar-title>
      </v-toolbar>
      <content-library class="d-flex"
                       @dismiss="dialog = false">
      </content-library>
    </v-card>
  </v-dialog>
</template>
<script>
import ContentLibrary from "./ContentLibrary";

export default {
  components: {ContentLibrary},
  data() {
    return {
      dialog: false,
    }
  }
}
</script>
